// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__k1ni0","imageUploader":"EGiftCard_imageUploader__2oByc"};